import React from 'react'

import cashOutErrorImage from '../../../../assets/cashOutError.png'
import styles from './styles.module.scss'

const CashOutError = () => (
  <div className={styles.container}>
    <img className="mb-32" src={cashOutErrorImage} alt="cash-out-error" />
    <p className="mb-8 medium bold">Your cash out amount is too high</p>
    <p className="neutral500 bodySmall">
      Your loan amount plus cash out amount cannot exceed 80% of your home’s value.
    </p>
    <p className="neutral500 bodySmall">Please adjust the values and try again.</p>
  </div>
)

export default CashOutError
